<div style="display: flex;justify-content: space-between;align-items: center">
  <div *ngIf="progress !== 100" class="progress-cont">
    <div class="progress" [style.width]="progress + '%'">
    </div>
  </div>
  <mat-icon className="material-icons" (click)="cancel()">highlight_off</mat-icon>
</div>

